import React, { useEffect, useState, useContext, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import useGoogleAnalytics from '../../CustomHooks/useGoogleAnalytics';
import ColorPicker from './ColorPicker';
import FontPicker from './FontPicker';
import Button from '@material-ui/core/Button';
import useFetch from '../../CustomHooks/useFetch';
import useGuiTranslations from '../MultiLanguage/useGuiTranslations';
import { capitalizeFirstLetter } from '../../Util/StringFunctions';


export default function ColorsAndFonts(props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const setGAPath = useGoogleAnalytics();
    const [selectedPrimaryColor, setSelectedPrimaryColor] = useState('#cc4646');
    const [selectedSecondaryColor, setSelectedSecondaryColor] = useState('#cc4646');
    const [selectedPrimaryFont, setSelectedPrimaryFont] = useState('B612');
    const [selectedSecondaryFont, setSelectedSecondaryFont] = useState('B612');
    const [selectedPrimaryTextColor, setSelectedPrimaryTextColor] = useState('#cc4646');
    const [selectedSecondaryTextColor, setSelectedSecondaryTextColor] = useState('#cc4646');
    const [backgroundColor, setBackgroundColor] = useState('#cc4646');
    const [getSettingsHookResponse, getSettingsHook] = useFetch();
    const [saveSettingsHookResponse, saveSettingsHook] = useFetch();
    const [translateGui] = useGuiTranslations();

    useEffect(
        () => {
            //GA
            setGAPath('/ColorsAndFonts');

            //Breadcrumb
            globalContext.dispatchMethod(
                {
                    type: 'SET_MENU_LOCATION',
                    value: {
                        a: 8,
                        b: 85,
                    },
                }
            )
        }, []
    )

    useEffect(
        () => {
            getSettingsHook(
                {
                    url: '/admin/customersettings/get-customization-settings',
                    method: 'GET',
                    postData: null,
                    addTokenHeader: true,
                }
            )
        }, []
    )

    useEffect(
        () => {
            if (getSettingsHookResponse.success) {
                if(getSettingsHookResponse.settings) {
                    let settings = JSON.parse (getSettingsHookResponse.settings);
                    setSelectedPrimaryColor(settings.primaryColor);
                    setSelectedSecondaryColor(settings.secondaryColor);
                    setSelectedPrimaryFont(settings.primaryFont);
                    setSelectedSecondaryFont(settings.secondaryFont);
                    setSelectedPrimaryTextColor(settings.primaryTextColor);
                    setSelectedSecondaryTextColor(settings.secondaryTextColor);
                    setBackgroundColor(settings.backgroundColor);
                }
                else {
                    setSelectedPrimaryColor('#233234');
                    setSelectedSecondaryColor('#453A32');
                    setSelectedPrimaryFont('Open Sans');
                    setSelectedSecondaryFont('Roboto');
                    setSelectedPrimaryTextColor('#675456');
                    setSelectedSecondaryTextColor('#555565');
                    setBackgroundColor('#FFFFFF');
                }
            }
        }, [getSettingsHookResponse]
    )


    const saveSetting = () => {
        globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '...', showButton: false } });
        saveSettingsHook(
            {
                url: '/admin/customersettings/update-customization-settings',
                method: 'PUT',
                postData: {
                    settings: {
                        primaryColor: selectedPrimaryColor,
                        secondaryColor: selectedSecondaryColor,
                        primaryFont: selectedPrimaryFont,
                        secondaryFont: selectedSecondaryFont,
                        primaryTextColor: selectedPrimaryTextColor,
                        secondaryTextColor: selectedSecondaryTextColor,
                        backgroundColor: backgroundColor,
                    },
                },
                addTokenHeader: true,
            }
        )
    }


    return (
        <div className={classes.root}>
            <ColorPicker label={capitalizeFirstLetter(translateGui(94))} selectedColor={selectedPrimaryColor} setSelectedColor={setSelectedPrimaryColor}></ColorPicker>
            <ColorPicker label={capitalizeFirstLetter(translateGui(95))} selectedColor={selectedSecondaryColor} setSelectedColor={setSelectedSecondaryColor}></ColorPicker>
            <FontPicker label={capitalizeFirstLetter(translateGui(96))} selectedFont={selectedPrimaryFont} setSelectedFont={setSelectedPrimaryFont}></FontPicker>
            <FontPicker label={capitalizeFirstLetter(translateGui(97))} selectedFont={selectedSecondaryFont} setSelectedFont={setSelectedSecondaryFont}></FontPicker>
            <ColorPicker label={capitalizeFirstLetter(translateGui(98))} selectedColor={selectedPrimaryTextColor} setSelectedColor={setSelectedPrimaryTextColor}></ColorPicker>
            <ColorPicker label={capitalizeFirstLetter(translateGui(99))} selectedColor={selectedSecondaryTextColor} setSelectedColor={setSelectedSecondaryTextColor}></ColorPicker>
            <ColorPicker label={capitalizeFirstLetter(translateGui(100))} selectedColor={backgroundColor} setSelectedColor={setBackgroundColor}></ColorPicker>
            <Button onClick={saveSetting} variant="contained" color="primary">
                {capitalizeFirstLetter(translateGui(45))}
            </Button>
        </div>
    )
}

const useStyles = makeStyles({
    root: {
        '& > div': {
            marginBottom: '15px',
        }
    },

});